// extracted by mini-css-extract-plugin
module.exports = {"container":"tariffs_container__QrhrY","iconTextContainer":"tariffs_iconTextContainer__2WxB5","iconContainer":"tariffs_iconContainer__JfKQr","BGImg":"tariffs_BGImg__G5LsT"};